import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  Clock, 
  AlertTriangle, 
  Mail, 
  ArrowUpCircle,
  LogOut
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function TrialExpiredPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleContactAdmin = () => {
    window.location.href = 'mailto:info@fedbd.ai?subject=Trial%20Extension%20Request&body=Hello,%0D%0A%0D%0AMy%20trial%20has%20expired%20and%20I%20would%20like%20to%20discuss%20subscription%20options.%0D%0A%0D%0AOrganization:%20' + (user?.organizationName || 'N/A') + '%0D%0AEmail:%20' + (user?.email || 'N/A');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="trial-expired-page">
      <Card className="max-w-lg w-full">
        <CardContent className="p-8 text-center">
          {/* Warning Icon */}
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-amber-600" />
          </div>
          
          {/* Title */}
          <h1 
            className="text-2xl font-bold text-slate-900 mb-3"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Your Trial Has Expired
          </h1>
          
          {/* Message */}
          <p className="text-slate-600 mb-6">
            Your 7-day free trial of FedBD has ended. To continue accessing your pursuits, 
            knowledge base, and AI-powered capture tools, please upgrade to a paid plan.
          </p>
          
          {/* User Info */}
          {user && (
            <div className="bg-slate-100 rounded-lg p-4 mb-6 text-left">
              <p className="text-sm text-slate-500">Account Information</p>
              <p className="font-medium text-slate-900">{user.email}</p>
              <p className="text-sm text-slate-600">{user.organizationName}</p>
            </div>
          )}
          
          {/* Actions */}
          <div className="space-y-3">
            <Button
              className="w-full bg-teal-700 hover:bg-teal-800 text-white"
              onClick={() => {
                const ws = (user?.workspaceId) ? `/${user.workspaceId}` : '';
                navigate(`${ws}/billing/subscribe`);
              }}
              data-testid="add-payment-btn"
            >
              <ArrowUpCircle className="w-4 h-4 mr-2" />
              Add Payment & Continue
            </Button>

            <Button
              variant="outline"
              className="w-full"
              onClick={handleContactAdmin}
              data-testid="contact-admin-btn"
            >
              <Mail className="w-4 h-4 mr-2" />
              Contact Admin
            </Button>

            <div className="flex items-center gap-3">
              <Button 
                variant="ghost" 
                className="flex-1 text-slate-600"
                onClick={() => navigate('/pricing')}
                data-testid="view-plans-btn"
              >
                View Plans
              </Button>
              
              <Button 
                variant="ghost" 
                className="flex-1 text-slate-600"
                onClick={handleLogout}
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Sign Out
              </Button>
            </div>
          </div>
          
          {/* Help Text */}
          <div className="mt-6 pt-6 border-t">
            <div className="flex items-start gap-2 text-left">
              <AlertTriangle className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-slate-500">
                Your data is safe. Once you upgrade, you'll regain full access to all your 
                pursuits and capture intelligence.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
